import { BaseService } from '@absg/nim-client-shared';
import { Injectable } from '@angular/core';
import { ipcRenderer } from 'electron';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ElectronApplicationService extends BaseService {
  fireRetryDomainFetch$ = new Subject<void>();
  ipcRenderer: typeof ipcRenderer;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  remote: any;

  constructor() {
    super();
    if (!window || !window.process || !window.require) {
      //  throw new Error('Unable to require renderer process');
      console.warn('Unable to require renderer process, we must not be running in Electron');
    } else {
      this.ipcRenderer = window.require('electron').ipcRenderer;
      this.remote = window.require('@electron/remote');
    }
  }

  createBrowserWindow(options: object): Electron.BrowserWindow {
    return new this.remote.BrowserWindow(options);
  }

  getCurrentWindow(): Electron.BrowserWindow {
    let currentWindow: Electron.BrowserWindow = null;

    if (this.isRunningElectron()) {
      currentWindow = window.require('@electron/remote').getCurrentWindow();
    }

    return currentWindow;
  }

  getIpcRenderer(): Electron.IpcRenderer {
    return this.ipcRenderer;
  }

  isRunningElectron(): boolean {
    // Renderer process
    if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
      return true;
    }

    // Main process
    if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
      return true;
    }

    // Detect the user agent when the `nodeIntegration` option is set to true
    if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
      return true;
    }

    return false;
  }
}
